// Havre Japan — fix shipping checkpoint dates to Japanese format
// Converts "4月 7th" → "4月7日", "4月 8th - 4月 9th" → "4月8日 - 4月9日"
(function() {
  function fixDates(root) {
    var els = (root || document).querySelectorAll('.shipping-checkpoints__date, [class*="shipping-checkpoint"] strong, .shipping-checkpoints strong');
    els.forEach(function(el) {
      var text = el.innerText || el.textContent;
      var fixed = text.replace(/(\d+月)\s+(\d+)(st|nd|rd|th)/g, '$1$2日');
      if (fixed !== text) {
        el.textContent = fixed;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    fixDates();
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.addedNodes.length) fixDates();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
